import {gsap} from 'gsap/all';

class CarouselVertical {
	constructor(el) {
		this.DOM = {el};
		this.DOM.nextElement = this.DOM.el.nextElementSibling;
		this.DOM.backgrounds = [...this.DOM.el.querySelectorAll('.pane__background-image')];
		this.DOM.cards = [...this.DOM.el.querySelectorAll('.pane__card')];
		this.DOM.bullets = this.DOM.el.querySelectorAll('.pane__bullet-list > .list__item');
		this.DOM.buttonPrevious = this.DOM.el.querySelector('.pane__btn-previous');
		this.DOM.buttonNext = this.DOM.el.querySelector('.pane__btn-next');

		this.totalSlides = this.DOM.bullets.length;
		this.current = 0;

		this.scrollTop = document.documentElement.scrollTop;
		this.scrollY = null;

		this.setStage();
		this.initEvents();
	}
	initEvents() {
		this.DOM.bullets.forEach((bullet, bulletIndex) => {
			bullet.addEventListener('click', () => {
				const direction = this.current > bulletIndex ? -1 : 1;
				this.navigate(direction, bulletIndex);
			});
        });
        this.DOM.buttonPrevious.addEventListener('click', () => {
            const selectedSlide = this.current - 1;
            this.navigate(-1, selectedSlide < 0 ? this.totalSlides - 1 : selectedSlide );
        });
        this.DOM.buttonNext.addEventListener('click', () => {
            const selectedSlide = this.current + 1;
            this.navigate(1, selectedSlide >= this.totalSlides ? 0 : selectedSlide );
        });
	}
	navigate(direction, selectedSlide) {
		/* Active slide */
		const activeElements = this.getCurrentElement();
		this.current =
			typeof selectedSlide !== 'undefined'
				? selectedSlide
				: direction === 1
				? this.current + 1
				: this.current - 1;
		const nextElements = this.getCurrentElement();

		this.tl = gsap
			.timeline({
				defaults: {ease: 'power4.inOut', duration: 1},
			})
			.addLabel('start');

		this.tl
			.to(
				activeElements.card,
				{
					y: direction === 1 ? -500 : 500,
					scale: 0.75,
					opacity: 0,
				},
				'start'
			)
			.to(
				activeElements.bg,
				{
					scale: direction === 1 ? 1.2 : 1,
					opacity: 0,
				},
				'start'
			)
			.to(
				nextElements.card,
				{
					y: 0,
					scale: 1,
					opacity: 1,
					onStart: () => {
						activeElements.bullet.classList['remove']('is-active');
						nextElements.bullet.classList['add']('is-active');
					},
				},
				'start'
			)
			.to(
				nextElements.bg,
				{
					scale: 1,
					opacity: 1,
				},
				'start'
            )
            .to(
                this.DOM.el,
                {
                    backgroundColor: this.current % 2 ? '#f1efeb' : '#ffffff',
                },
                'start'
            );
	}
	setStage() {
		this.current = 0;
		const {card, bg, bullet} = this.getCurrentElement();

		gsap.to(card, {y: 0, scale: 1, opacity: 1});
		gsap.to(bg, {opacity: 1, scale: 1});
		bullet.classList.add('is-active');
	}
	getCurrentElement() {
		const card = this.DOM.cards[this.current];
		const bg = this.DOM.backgrounds[this.current];
		const bullet = this.DOM.bullets[this.current];

		return {card, bg, bullet};
	}
}

const carouselVerticalNodes = document.querySelectorAll('.pane--carousel-sticky');
[...carouselVerticalNodes].forEach((node) => new CarouselVertical(node));
